/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, themeV2, coloredScrollBar } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.modalpage': { 
      width: '100%',
      maxWidth: '640px !important',
      borderRadius: pxToEm(12),
      '& .close': {
        border: 'none',
        paddingTop: pxToEm(16),
        '& .icon': {
          color: '#061240'
        }
      }
    },
    '.buttonconfigmodal': {
      maxWidth: '640px !important',
      width: '100%',
      '& .headericons .icon': {
        height: '70px',
        width: '70px',
        border: '2px solid #CCD1E6',
        borderRadius: '12px',
        padding: '18px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s',
        '&:hover': {
          border: '2px solid #97A1CA'
        },
        '&.selected-true': {
          border: '2px solid #3257EC'
        },
        '&.none': {
          background: '#F7F8FC'
        },
        '& img': {
          height: '24px',
          width: 'auto'
        }
      },
      '& .singleselectdropdown': {
        zIndex: 'auto',
        height: pxToEm(76),
        '& .placeholder': {
          padding: pxToEm(16)
        }
      },
      '& .colorpicker': {
        width: 'auto'
      },
      '& .primarycolor': {
        '&.disabled-true': {
          '& .swatch': {
            pointerEvents: 'none'
          },
          '& input': {
            pointerEvents: 'none',
            opacity: 0.4
          }
        },
        '& .picker': {
          '& .chrome-picker': {
            '& > div:first-child': {
              display: 'none'
            },
            '& div:last-child > div:last-child > div:last-child': {
              display: 'block',
              marginTop: `0 !important`
            }
          },
        }
      },
      '& .name-menuItems': {
        zIndex: '999 !important',
        position: 'relative'
      },
      '& > h4': {
        borderBottom: '3px solid #000',
        paddingBottom: pxToEm(8),
      },
      '& .header': {
        width: '100% !important',
      },
      overflowY: 'auto',
      overflowX: 'hidden',
      extend: coloredScrollBar(themeV2.color.base.scrollbar),
      fontSize: pxToEm(14),
      padding: pxToEm(14),
      '& button': { width: '100%'},
      '& h4': {
        marginBottom: pxToEm(20),
        fontSize: '20px'
      },
      '& .changelist': {
        textAlign: 'left',
        margin: `${pxToEm(16)} ${pxToEm(24)}`,
      },
      '& ul': {
        margin: pxToEm(8),
        marginBottom: pxToEm(16),
        color: themeV2.color.base.gray.dark,
        '& li': {
          textAlign: 'left',
          marginLeft: pxToEm(16)
        }
      },
      '& .errormessage': {
        display: 'block',
        color: themeV2.color.error.main
      },
      '& .sectiongroupv2': {
        width: '100% !important'
      },
      '& .content': {
        height: pxToEm(280),
        padding: pxToEm(16)
      },
      '& .buttonpreviewcontainer': {
        width: '100%',
        display: 'flex',

        '&.LEFT': {
          justifyContent: 'flex-start'
        },
        '&.RIGHT': {
          justifyContent: 'flex-end'
        },
        '&.CENTER': {
          justifyContent: 'center'
        }
      },
      '& .buttonpreview': {
        borderRadius: pxToEm(32),
        background: '#061240',
        color: '#FFFFFF',
        minWidth: pxToEm(120),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: pxToEm(6),
        boxSizing: 'border-box',
        padding: '6px 8px',
        '& svg path': {
          fill: '#FFF !important'
        },
        '& svg': {
          width: pxToEm(22),
          height: pxToEm(22)
        },
        '&.SMALL': {
          height: '32px'
        },
        '&.MEDIUM': {
          height: '36px',
          padding: '6px 10px'
        },
        '&.LARGE': {
          height: '56px',
          padding: '14px'
        },
        '&.DECORATIVE': {
          fontFamily: '"Source Serif Pro", serif'
        },
        '&.PLAIN': {
          fontFamily: '"Work Sans", sans-serif'
        }
      }
    }
  }
});
